export default __webpack_public_path__ + "static/media/rapidrevision_icon.e2e34136.svg";